<button mat-icon-button [matMenuTriggerFor]="userMenu">
  <mat-icon>account_circle</mat-icon>
</button>
<mat-menu #userMenu="matMenu">
  <button mat-menu-item disabled>
    <mat-icon>person</mat-icon>
    <span>{{ authService.getFullName() }}</span>
  </button>
  <a mat-menu-item [href]="authService.getAccountUrl()" target="_blank" rel="noopener noreferrer">
    <mat-icon>manage_accounts</mat-icon>
    <span>Account</span>
  </a>
  <button mat-menu-item (click)="authService.logout()">
    <mat-icon>logout</mat-icon>
    <span>Sign out</span>
  </button>
  @if (pwaService.isServiceWorkerEnabled()) {
    <button mat-menu-item (click)="resetApp()">
      <mat-icon>refresh</mat-icon>
      <span>Reset App</span>
    </button>
  }
  <mat-divider></mat-divider>
  @if (updating()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <div class="menu-version-label" (click)="checkUpdates()">v{{ version }}</div>
</mat-menu>
